"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const file_saver_1 = require("file-saver");
const react_1 = __importStar(require("react"));
const use_query_params_1 = require("use-query-params");
const core_1 = require("@material-ui/core");
const core_ui_1 = require("@sierralabs/core-ui");
const useDeleteQuery_1 = require("../../hooks/useDeleteQuery");
const useUpdateQuery_1 = require("../../hooks/useUpdateQuery");
const QueryContext_1 = require("../../QueryContext");
const QueryListMenuButton = ({ query }) => {
    const [showDeleted] = (0, use_query_params_1.useQueryParam)('show-deleted', use_query_params_1.BooleanParam);
    const { getQueryGroups } = (0, QueryContext_1.useQueryContext)();
    const { updatedQuery, updateQuery } = (0, useUpdateQuery_1.useUpdateQuery)(query.id);
    const { deletedQuery, deleteQuery } = (0, useDeleteQuery_1.useDeleteQuery)(query.id);
    const [openConfirmDialog, setOpenConfirmDialog] = (0, react_1.useState)(false);
    const [queryMenuAnchor, setQueryMenuAnchor] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        getQueryGroups({ includeDeleted: showDeleted });
        setQueryMenuAnchor(null);
    }, [
        updatedQuery,
        deletedQuery,
        showDeleted,
        getQueryGroups,
        setQueryMenuAnchor
    ]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.IconButton, { size: 'small', onClick: event => {
                event.preventDefault();
                setQueryMenuAnchor(event.currentTarget);
            } },
            react_1.default.createElement(core_1.Icon, { className: 'more-icon' }, "more_vert")),
        react_1.default.createElement(core_1.Menu, { id: 'query-more-menu', anchorEl: queryMenuAnchor, getContentAnchorEl: null, anchorOrigin: { vertical: 'bottom', horizontal: 'left' }, transformOrigin: { vertical: 'top', horizontal: 'left' }, open: Boolean(queryMenuAnchor), onClose: () => {
                setQueryMenuAnchor(null);
            } },
            react_1.default.createElement(core_1.MenuItem, { onClick: () => {
                    setQueryMenuAnchor(null);
                    const exportQuery = Object.assign({}, query);
                    delete exportQuery.deleted;
                    const blob = new Blob([JSON.stringify(exportQuery, undefined, 2)], {
                        type: 'application/json'
                    });
                    (0, file_saver_1.saveAs)(blob, `${query.name} Query.json`);
                } }, "Export Query"),
            react_1.default.createElement(core_1.MenuItem, { onClick: () => {
                    (query === null || query === void 0 ? void 0 : query.deleted)
                        ? updateQuery({ deleted: null })
                        : setOpenConfirmDialog(true);
                } }, query.deleted ? 'Undelete Query' : 'Delete Query')),
        react_1.default.createElement(core_ui_1.ConfirmDialog, { open: openConfirmDialog, title: 'Delete Query Group', message: `Are you sure you want to delete the "${query.name}" query? `, confirmLabel: 'Delete', onCancel: () => setOpenConfirmDialog(false), onConfirm: () => {
                setOpenConfirmDialog(false);
                deleteQuery();
            } })));
};
exports.default = QueryListMenuButton;
//# sourceMappingURL=QueryMenuButton.js.map